import { IstanzaAttivitaVO } from "./istanza-attivitaVO";

export class AttivitaEreditataVO {
  attivitaAssociata: IstanzaAttivitaVO;
  idFascicolo: string;
}
